import {useDispatch, useSelector} from 'react-redux';

import {WorkspaceRequest} from 'src/openapi/admin/models/WorkspaceRequest';

import {UserPageState, resetScopeCriteria, setScopeCriteria} from '../slices/workspacesSlice';

export function useWorkspaceCriteria(scopeKey: string) {
    const dispatch = useDispatch();
    const criteria = useSelector(
        (state: UserPageState) => state.userPage.tabs.content.workspaces.criteriaByScope[scopeKey],
    );

    const setCriteria = (patch: Partial<WorkspaceRequest>) => {
        dispatch(setScopeCriteria({scopeKey, patch}));
    };

    const reset = () => {
        dispatch(resetScopeCriteria(scopeKey));
    };

    const setPage = (page: number) => {
        setCriteria({pagination: {...criteria.pagination, currentPage: page}});
    };

    const setPageSize = (size: number) => {
        setCriteria({pagination: {...criteria.pagination, currentPage: 1, pageSize: size}});
    };

    const setSort = (
        sortBy: WorkspaceRequest['sortBy'],
        sortDirection: WorkspaceRequest['sortDirection'],
    ) => {
        setCriteria({sortBy, sortDirection});
    };

    return {criteria, setCriteria, setPage, setSort, reset, setPageSize};
}
